module.exports = __webpack_public_path__ + "media/images/landing__seasonPrize__prize4-c1c41df949e0e3ebf0d489f2219803e7.jpg";